'use client';

import { useEffect } from 'react';

import { useAdyen } from '../../hooks';
import type { AdyenFormProps } from './types';

import '@adyen/adyen-web/dist/adyen.css';
import './AdyenForm.scss';

export function AdyenForm({ setAdyenForm, setAdyenFormState }: AdyenFormProps) {
    const { adyenForm, adyenFormState } = useAdyen();

    useEffect(() => {
        setAdyenForm(adyenForm);
        setAdyenFormState(adyenFormState);
    }, [adyenForm, adyenFormState]);

    return (
        <div className="adyen-form" data-testid="adyen-form">
            <div id="adyen-card-container" data-cs-mask />
        </div>
    );
}
